/// <amd-module name="VSSUI/Duration" />
export * from "./Components/Time/Duration/Duration";
export { IDurationProps } from "./Components/Time/Duration/Duration.Props";
